/* ------------------------------------------------------------------------
   Stacked-cards article: the cards that already have a later card on top of
   them shrink a little, one step per card on top, so the stack reads as
   depth. Pure decoration; without this script the cards still pin and stack.
   ------------------------------------------------------------------------ */
(function () {
	var items = Array.prototype.slice.call(document.querySelectorAll('[data-kc-stack-item]'));
	if (!items.length) return;
	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

	var pinned = window.matchMedia('(min-width: 750px) and (min-height: 700px)');
	var ticking = false;
	var STEP = 16; /* px each card pins below the previous one (matches the CSS) */
	var MIN_TOP = 96; /* never closer to the top than the header */
	var LIFT = 48; /* pin a little above the exact middle, which looks more natural */

	/* Pin the stack in the middle of the window. The position is worked out from a
	   typical (median) card, so one long card does not push the whole stack up.
	   A card that is taller than that pins as high as it needs to, so its bottom
	   is never cut off by the window. */
	function centre() {
		var heights = items.map(function (item) {
			var card = item.firstElementChild;
			return card ? card.offsetHeight : 0;
		});
		var sorted = heights.slice().sort(function (a, b) { return a - b; });
		var typical = sorted[Math.floor(sorted.length / 2)];
		var vh = window.innerHeight;
		var base = Math.max(MIN_TOP, Math.round((vh - typical - (items.length - 1) * STEP) / 2) - LIFT);
		items.forEach(function (item, i) {
			if (!pinned.matches) {
				item.style.top = '';
				return;
			}
			var top = Math.min(base + i * STEP, vh - heights[i] - 24);
			item.style.top = Math.max(MIN_TOP - 40, Math.round(top)) + 'px';
		});
	}

	function stickyTop(el) {
		return parseFloat(window.getComputedStyle(el).top) || 0;
	}

	function update() {
		ticking = false;
		items.forEach(function (item, i) {
			var card = item.firstElementChild;
			if (!card) return;
			if (!pinned.matches) {
				card.style.transform = '';
				return;
			}
			var depth = 0;
			for (var j = i + 1; j < items.length; j++) {
				var top = items[j].getBoundingClientRect().top;
				if (top <= stickyTop(items[j]) + 1) depth++;
			}
			card.style.transform = depth ? 'scale(' + (1 - 0.025 * depth).toFixed(3) + ')' : '';
		});
	}

	function onScroll() {
		if (!ticking) {
			ticking = true;
			window.requestAnimationFrame(update);
		}
	}

	function onResize() {
		centre();
		onScroll();
	}

	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', onResize);
	window.addEventListener('load', onResize);
	if (document.fonts && document.fonts.ready) document.fonts.ready.then(onResize);
	centre();
	update();
})();
